import {ISpecification} from "@/models/specifications/SpecificationHelpers/ISpecification";
import {IShipmentStore} from "@/models/StoreModels";
import {MAX_CHAR} from "@/constants/orders";

export class StoreShipmentNoteIsCorrect implements ISpecification<IShipmentStore> {
  public IsSatisfiedBy(candidate: IShipmentStore): boolean {
    return candidate.note.length <= MAX_CHAR;
  }
}
